module.exports = __webpack_public_path__ + "img/ise.54179b71.png";